// const API_URL = 'https://api.adsrun.kr/';
// const API_URL = 'https://api-test.adsrun.kr/';
// const API_URL = 'http://localhost/';

const API_URL = 'https://api-momenti.bridgesoft.co.kr'; // DEV
// const API_URL = 'https://dev-api-record.bridgesoft.co.kr'; // DEV
// const API_URL = 'http://3.37.113.145:28080'; // DEV
// const API_URL = 'http://localhost:28080'; // LOCAL
export default API_URL



// WEBPACK FOOTER //
// ./src/common/url.js